import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  Status,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole,
  writeClipboard,
  isExpiredCancel,
  CopyCell,
  captureShareImage,
  sendShareToTelegram,
  downloadShareImage,
  getShareTitle,
  StatusTnxShare,
  maskAccount,
} from "../../components/CustomComponent.js";

import { NumericFormat } from "react-number-format";

import LOGO512 from "../../assets/images/logo512.png";
import WATERMARK from "../../assets/images/watermark.png";

import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";

const countdownInitial = 60;

// every column of the mismatch table, in render order. the column manager
// builds its checkbox list straight from this, so adding a column here is
// enough for it to show up in the menu.
const columnDefs = () => [
  { key: "time", label: "Time" },
  { key: "ref_no", label: "Ref No" },
  { key: "ref_qr", label: "Ref QR" },
  { key: "customer", label: "Customer" },
  { key: "bank", label: "Bank" },
  { key: "amount", label: "Amount" },
  { key: "fee_rate", label: "Fee %" },
  { key: "fee", label: "Fee" },
  { key: "vat", label: "VAT" },
  { key: "amount_net", label: "Amount Net" },
  { key: "process", label: "Process" },
  { key: "status", label: "Status" },
  { key: "actions", label: "Actions" },
];

const columnStorageKey = () => "columns-mismatch";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const pageSizeStorageKey = () => "page-size-mismatch";

const loadPageSize = () => {
  const saved = Number(localStorage.getItem(pageSizeStorageKey()));
  return PAGE_SIZE_OPTIONS.includes(saved) ? saved : 10;
};

const loadColumns = () => {
  const columns = {};
  columnDefs().forEach((column) => {
    columns[column.key] = true;
  });
  try {
    const saved = JSON.parse(localStorage.getItem(columnStorageKey()) || "{}");
    Object.keys(columns).forEach((key) => {
      if (typeof saved[key] === "boolean") columns[key] = saved[key];
    });
  } catch (e) {}
  return columns;
};
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_refund: false,
      modal_detail: false,

      // SEARCH
      filter_start_date: "",
      filter_end_date: "",
      filter_data_search: "",
      filter_broker_id: "",
      filter_currency: "THB",

      // TABLE
      columns: loadColumns(),
      page: 1,
      page_size: loadPageSize(),
      table_updated_at: "",
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,

      // EXPORT
      export_date: "",

      // LIST
      loaded: false,
      data: [],
      count: 10,
      data_broker: [],

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      broker: null,
      customer: null,

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      mismatch_bank_account_number: "",

      refund_amount: "",

      modal_share: false,
      share_image: null,
      chat_id: "",

      hover_info_index: -1,
      inline_help_popup: null,
    };
    this.tableRefreshInterval = null;
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }

  componentWillUnmount() {
    this.StopTableAutoRefresh();
  }

  setPageSize = (page_size) => {
    localStorage.setItem(pageSizeStorageKey(), String(page_size));
    // page 1 again: the row the user was looking at lands somewhere else once
    // the page size changes, so keeping the page number would be misleading
    this.setState({ page_size }, () => {
      this.Get(1);
    });
  };

  resetColumns = () => {
    localStorage.removeItem(columnStorageKey());
    this.setState({ columns: loadColumns() });
  };

  StartTableAutoRefresh = () => {
    if (this.tableRefreshInterval) return;

    this.setState({
      table_auto_refresh: true,
      table_refresh_countdown: countdownInitial,
    });

    this.tableRefreshInterval = setInterval(async () => {
      const { table_auto_refresh, table_refresh_countdown, page } = this.state;

      if (!table_auto_refresh) return;

      if (table_refresh_countdown <= 1) {
        // silent + current page: refreshing must not flash the full-screen loader
        await this.Get(page, { silent: true });
        this.setState({ table_refresh_countdown: countdownInitial });
        return;
      }

      this.setState({
        table_refresh_countdown: table_refresh_countdown - 1,
      });
    }, 1000);
  };

  StopTableAutoRefresh = () => {
    if (this.tableRefreshInterval) {
      clearInterval(this.tableRefreshInterval);
      this.tableRefreshInterval = null;
    }

    this.setState({
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,
    });
  };

  ToggleTableAutoRefresh = () => {
    if (this.state.table_auto_refresh) {
      this.StopTableAutoRefresh();
      return;
    }

    this.StartTableAutoRefresh();
  };

  isColumn = (key) => this.state.columns?.[key] !== false;

  toggleColumn = (key) => {
    this.setState((prevState) => {
      const columns = { ...prevState.columns, [key]: !prevState.columns[key] };
      localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
      return { columns };
    });
  };

  toggleAllColumns = (checked) => {
    const columns = {};
    columnDefs().forEach((column) => {
      columns[column.key] = checked;
    });
    localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
    this.setState({ columns });
  };

  showInlineHelpPopup = (event, popup) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 260;
    const left = Math.min(
      Math.max(rect.left - 8, 16),
      window.innerWidth - popupWidth - 16,
    );
    const top = Math.max(rect.top - 16, 16);

    this.setState({ inline_help_popup: { ...popup, left, top } });
  };

  hideInlineHelpPopup = () => {
    this.setState({ inline_help_popup: null });
  };

  copyInlineHelpText = async (text) => {
    if (!(await writeClipboard(text))) return;
    this.setState((prevState) =>
      prevState.inline_help_popup
        ? {
            inline_help_popup: {
              ...prevState.inline_help_popup,
              copied: true,
            },
          }
        : null,
    );
  };
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker;
    let [result_broker] = await Promise.all([
      GET("v1/admin/brokers/options", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    this.setState({ data_broker });
  };
  Get = async (page, options = {}) => {
    const { silent = false } = options;
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_broker_id,
      filter_currency,
      page_size,
    } = this.state;
    let data, count;
    if (!silent) {
      loading(true);
    }
    let [result] = await Promise.all([
      GET(`profits/list-mismatch`, {
        page_size: page_size,
        page: page,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: "mismatch",
        currency: filter_currency,
        broker_id: filter_broker_id,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      loaded: true,
      data,
      count,
      page: page || 1,
      table_updated_at: format_date(new Date(), "hh:mm:ss", "en"),
    });
    if (!silent) {
      loading(false);
    }
  };
  Update = async () => {
    const { fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
    // fee_type / fee_rate are nullable in the DB (and fee_rate may arrive as a
    // number); calling .trim() on them directly threw inside the setState
    // callback and made Approve / Reject from the row menu fail silently
    if (!String(fee_type ?? "").trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!String(fee_rate ?? "").trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (["cancel", "success"].includes(status)) {
      Swal.fire({
        title: "Confirm",
        text: `Do you want to ${
          status === "cancel" ? "Reject" : "Approve"
        } the transaction?`,
        icon: "info",
        input: "textarea",
        inputPlaceholder: "Enter remark...",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      }).then(async (re) => {
        if (re.isConfirmed) {
          const remark = re.value;
          loading(true);
          let body = {
            fee_type,
            fee_rate: Number(fee_rate).toFixed(4),
            is_vat,
            status,
            is_usdt,
            remark,
          };

          let result = await PUT(
            `transactions/deposits/update/` + this.state.uid,
            body
          );
          if (result?.status) {
            alert("#", "success");
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again."
            );
          }
          loading(false);
        }
      });
    } else {
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel"
        )
      ) {
        loading(true);
        let body = {
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          status,
          is_usdt,
        };

        let result = await PUT(
          `transactions/deposits/update/` + this.state.uid,
          body
        );
        if (result?.status === true) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again."
          );
        }
        loading(false);
      }
    }
  };
  Refund = async () => {
    const { refund_amount, uid } = this.state;
    if (!refund_amount) {
      alert("", "warning", "Warning", "Please input Refund Amount");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to refund this transaction?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        uid,
        amount: Number(refund_amount),
      };

      let routeRefund = this.state.currency === "LAK" ? "transactions/withdrawals/refund/lak" : "transactions/withdrawals/refund";

      let result = await POST(routeRefund, body);
      if (result?.status) {
        alert("", "success");
        this.setState({ modal_refund: false });
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  
    ExportCSV = async () => {
          const {
            filter_data_search,
            filter_start_date,
            filter_end_date,
          } = this.state;
          loading(true);
          let result = await GET(`profits/list-mismatch`, {
             page_size: 1000000,
          page: 0,
          data_search: filter_data_search,
          start_date: filter_start_date
            ? format_date(filter_start_date, "yyyy-mm-dd", "en")
            : "",
          end_date: filter_end_date
            ? format_date(filter_end_date, "yyyy-mm-dd", "en")
            : "",
          filter_status: "mismatch",
          currency: "",
          });
          if (result?.status) {
            const data_transaction = result.data;
      
            // EXPORT CSV
            const json_data = data_transaction.map((item) => ({
              time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
              "Ref No": item.ref_no,
              RefQR: item.reference_id,
              Broker: item.broker?.name_en || "-",
              Customer: item.customer?.name_en || "-",
              Amount: toFixed(item.amount, 2),
              Fee: toFixed(item.fee, 2),
              "VAT Type": item.is_vat ? "VAT" : "NO VAT",
              VAT: item.is_vat ? toFixed(item.vat, 2) : "-",
              "Amount Net": toFixed(item.amount_net, 2),
              Process:
                item.process_type === "manual"
                  ? "Manual"
                  : item.process_type === "auto"
                    ? "Auto"
                    : "-",
              Status: item.ref_no_refund ? "refund" : (item.status || "-"),
              Remark: item.remark,
              currency: item.currency,
            }));
            // 1. Convert JSON to worksheet
            const worksheet_thb = XLSX.utils.json_to_sheet(
              json_data.filter((e) => e.currency === "THB"),
            );
            const worksheet_lak = XLSX.utils.json_to_sheet(
              json_data.filter((e) => e.currency === "LAK"),
            );
      
            // 2. Create a new workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet_thb, "THB");
            XLSX.utils.book_append_sheet(workbook, worksheet_lak, "LAK");
      
            // 3. Write the workbook to binary buffer
            const excelBuffer = XLSX.write(workbook, {
              bookType: "xlsx",
              type: "array",
            });
      
            // 4. Save to file
            const data = new Blob([excelBuffer], {
              type: "application/octet-stream",
            });
            saveAs(
              data,
              `mismatch-${format_date(
                filter_start_date,
                "dd/mm/yy",
                "en",
              )}-${format_date(filter_end_date, "dd/mm/yy", "en")}.xlsx`,
            );
          }
          loading(false);
        };

        // SHARE

  Share = async (item) => {
    this.setState({ ...item, chat_id: global.chat_room[0].list[0].value });
    if(item.ref_no_refund){
     let result = await GET(`transactions/withdrawals/list`, { data_search: item.ref_no_refund });
     if (result?.status) {
      const data_transaction = result.data;
      this.setState({...data_transaction[0]})
     }
    }
    if (!this.share) return;
    loading(true);

  const image = await captureShareImage(this.share);
  this.setState({modal_share: true, share_image: image});

  loading(false);
  };
  SubmitShare = async () => {
    loading(true);
    const {share_image, chat_id, type, status, ref_no, ref_no_refund} = this.state;
    await sendShareToTelegram(chat_id, ref_no_refund ? ('' + getShareTitle(type, status) + '\nDeposit Ref No: ' + ref_no_refund + '\nRefund Ref No: ' + ref_no) : ('' + getShareTitle(type, status) + '\nRef No: ' + ref_no), share_image);
    loading(false);
     alert("", "success");
        this.setState({modal_share: false});

  }
  DownloadShare = async () => {
    const {share_image} = this.state;
    downloadShareImage(share_image);
  }

  // ชื่อธนาคารจาก code ฝั่ง mismatch ซึ่งบางครั้งมาเป็น code ย่อย เลยต้องเทียบทั้ง value และ code
  findMismatchBank = (code) => (code ? global.bank?.find((b) => b.value === code || b.code === code) : null);

  render() {
    const {
      modal_refund,
      modal_detail,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_currency,
      filter_broker_id,
      loaded,
      data,
      count,
      data_broker,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      amount_net,
      remark,
      broker,
      customer,
      cost_gateway,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      mismatch_bank_account_number,
      mismatch_bank_code,
      mismatch_bank_account_name_en,
      mismatch_bank_account_name_th,

      is_topup,
      ref_no_refund,
      currency,
      status_reason,

      refund_amount,

      modal_share,
      share_image,
      chat_id,
      inline_help_popup,
      hover_info_index,
      page,
      page_size,
      table_updated_at,
      table_auto_refresh,
      table_refresh_countdown,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const visibleColumns = columnDefs().filter((column) => this.isColumn(column.key));
    const selectedBrokerLabel = data_broker?.find((b) => b.value === filter_broker_id)?.label;
    const bankIcon = (code) => global.bank?.find((b) => b.value === code)?.icon || "bank.png";
    const mismatchBank = this.findMismatchBank(mismatch_bank_code);
    const mismatchBankIcon = global.bank?.find((b) => JSON.stringify(b).includes(mismatch_bank_code))?.icon || "bank.png";
    const mismatchBankName = global.bank?.find((b) => JSON.stringify(b).includes(mismatch_bank_code))?.value || "-";
    const cur = currency || "THB";
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {inline_help_popup && (
            <div
              className="inline-help-popup"
              style={{
                left: inline_help_popup.left,
                top: inline_help_popup.top,
              }}
            >
              <div
                className="fw-semibold mb-1"
                style={{
                  fontSize: 12,
                  color: inline_help_popup.titleColor || "#344054",
                }}
              >
                {inline_help_popup.title}
              </div>
              {inline_help_popup.lines?.map((line, idx) => (
                <div key={`inline-help-${idx}`} className="text-14">
                  {line}
                </div>
              ))}
              {inline_help_popup.copyable && (
                <div
                  className="fw-semibold mt-1"
                  style={{
                    fontSize: 11,
                    color: inline_help_popup.copied ? "#079455" : "#98a2b3",
                  }}
                >
                  {inline_help_popup.copied ? "Copied!" : "Click to copy"}
                </div>
              )}
            </div>
          )}

          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Reconciliation</div>
                <div className="ar-title">Mismatch Reports</div>
                <div className="ar-subtitle">Identify and resolve transaction discrepancies between the paying account and the registered customer.</div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-ghost mismatchs.read"
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  <span className="icon me-2">{""}</span>Export CSV
                </button>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search ref no, customer..."
                onChange={(e) => {
                  this.setState({ filter_data_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_data_search}
              />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Broker</span>
                <Select
                  className="form-control"
                  placeholder="All brokers"
                  options={data_broker}
                  onChange={(e, i) => {
                    this.setState({ filter_broker_id: e });
                  }}
                  value={filter_broker_id}
                />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Date Range</span>
                <DateRangePicker
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      filter_start_date: e.start_date,
                      filter_end_date: e.end_date,
                    });
                  }}
                  value={{
                    start_date: filter_start_date,
                    end_date: filter_end_date,
                  }}
                  max={filter_end_date}
                />
                </div>
              <div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() =>
                  this.setState(
                    {
                      filter_data_search: "",
                      filter_start_date: "",
                      filter_end_date: "",
                      filter_broker_id: "",
                      filter_currency: "THB",
                    },
                    () => this.Get(1)
                  )
                }
              >
                Reset
              </button>
              </div>
              </div>
              <div className="ar-filter-foot">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {global.currency?.map((item) => (
                  <button
                    key={item.currency_code}
                    className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                    onClick={() => {
                      this.setState({ filter_currency: item.currency_code });
                      setTimeout(() => {
                        this.Get(1);
                      }, 100);
                    }}
                  >
                    {item.image}
                    {item.currency_code}
                  </button>
                ))}
              </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head flex-wrap gap-2">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Mismatches
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">
                  {count > 0 ? `Showing ${(page - 1) * page_size + 1}–${Math.min(page * page_size, count)} of ${count}` : "No results"}
                  {selectedBrokerLabel ? <span className="ms-2">&middot; {selectedBrokerLabel}</span> : null}
                  {table_updated_at ? <span className="ms-2">&middot; Updated {table_updated_at}</span> : null}
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <button
                  type="button"
                  className="pu-om-ctl pu-ctl-plain"
                  onClick={() => {
                    this.Get(page, { silent: true });
                  }}
                >
                  <span className="icon me-1">{""}</span>Refresh
                </button>
                <button
                  type="button"
                  className={`pu-om-ctl pu-ctl-plain ${table_auto_refresh ? "active" : ""}`}
                  onClick={() => {
                    this.ToggleTableAutoRefresh();
                  }}
                >
                  <span className="icon me-1">{""}</span>
                  {table_auto_refresh ? `Auto ${table_refresh_countdown}s` : "Auto"}
                </button>
                <Select
                  className="form-control pu-om-rows pu-rows-plain"
                  placeholder="Rows"
                  options={PAGE_SIZE_OPTIONS.map((size) => ({
                    value: size,
                    label: `${size} rows`,
                  }))}
                  value={page_size}
                  onChange={(v) => {
                    this.setPageSize(Number(v));
                  }}
                />
                <Dropdown autoClose="outside" align="end">
                  <Dropdown.Toggle className="pu-om-ctl pu-ctl-plain" id="mismatch-columns">
                    <span className="icon me-1">{""}</span>Columns
                    <span className="pu-om-ctl-count">
                      {visibleColumns.length}/{columnDefs().length}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="pu-action-menu" style={{ minWidth: 190, maxHeight: 340, overflowY: "auto" }}>
                    <label className="pu-om-col fw-bold">
                      <input
                        type="checkbox"
                        className="form-check-input m-0 me-2"
                        checked={columnDefs().every((column) => this.isColumn(column.key))}
                        onChange={(e) => {
                          this.toggleAllColumns(e.target.checked);
                        }}
                      />
                      All columns
                    </label>
                    <div className="pu-action-sep" />
                    {columnDefs().map((column) => (
                      <label key={`column-${column.key}`} className="pu-om-col">
                        <input
                          type="checkbox"
                          className="form-check-input m-0 me-2"
                          checked={this.isColumn(column.key)}
                          onChange={() => {
                            this.toggleColumn(column.key);
                          }}
                        />
                        {column.label}
                      </label>
                    ))}
                    <div className="pu-action-sep" />
                    <button
                      type="button"
                      className="pu-om-col pu-om-col-reset"
                      onClick={() => {
                        this.resetColumns();
                      }}
                    >
                      Reset to default
                    </button>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: 400 }}>
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    {this.isColumn("time") && <td className="text-nowrap">Time</td>}
                    {this.isColumn("ref_no") && <td className="text-nowrap">Ref No</td>}
                    {this.isColumn("ref_qr") && <td className="text-nowrap">Ref QR</td>}
                    {this.isColumn("customer") && <td className="text-nowrap">Customer</td>}
                    {this.isColumn("bank") && <td className="text-nowrap">Bank</td>}
                    {this.isColumn("amount") && <td className="text-nowrap text-end">Amount</td>}
                    {this.isColumn("fee_rate") && <td className="text-nowrap text-end">Fee %</td>}
                    {this.isColumn("fee") && <td className="text-nowrap text-end">Fee</td>}
                    {this.isColumn("vat") && <td className="text-nowrap text-end">VAT</td>}
                    {this.isColumn("amount_net") && <td className="text-nowrap text-end">Amount Net</td>}
                    {this.isColumn("process") && <td className="text-nowrap text-center">Process</td>}
                    {this.isColumn("status") && <td className="text-nowrap text-center wpx-100">Status</td>}
                    {this.isColumn("actions") && <td className="mismatchs.update text-nowrap text-center td-actions">Actions</td>}
                  </tr>
                </thead>
                <tbody>
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={visibleColumns.length || 1} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No mismatches found</div>
                          <div className="text-secondary text-14">Try another search, broker, date range or currency.</div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.map((item, index) => {
                    const custName = item.customer?.name_en || item.customer?.name_th || "-";
                    const brokerName = item.broker?.name_en || item.broker?.name_th || "-";
                    const bank = item.bank_code ? global.bank.find((e) => e.value === item.bank_code) : null;
                    const idLines = [`originID: ${item.customer?.gateway_register?.[0]?.customer_id ?? "-"}`, `payoutID: ${item.customer?.gateway_register?.[0]?.uid ?? "-"}`];
                    return (
                      <tr key={item.uid || `array-${index}`}>
                        {this.isColumn("time") && (
                          <td data-label="Time" className="text-nowrap">
                            <div className="pu-shq-time">{format_date(item.created_at, "dd/mm/yy", "en")}</div>
                            <div className="pu-sub pu-mono">{format_date(item.created_at, "hh:mm:ss", "en")}</div>
                          </td>
                        )}
                        {this.isColumn("ref_no") && (
                          <td data-label="Ref No" className="text-nowrap">
                            <div className="pu-uid">
                              <CopyCell value={item.ref_no} className="pu-shq-ref" duration={2000} />
                              {item.ref_no_refund && (
                                <div className="pu-sub">
                                  refund: <span className="pu-mono ms-1">{item.ref_no_refund}</span>
                                  <span
                                    className="icon ms-1 pu-link pointer"
                                    title="Open refund transaction"
                                    onClick={() => {
                                      window.location.href = `/${linkRole(profile?.user_type)}/deposits-withdrawals?type=withdrawals&ref_no=${item.ref_no_refund}`;
                                    }}
                                  >
                                    {""}
                                  </span>
                                </div>
                              )}
                            </div>
                          </td>
                        )}
                        {this.isColumn("ref_qr") && (
                          <td data-label="Ref QR" className="text-nowrap">
                            {item.qrs?.reference_id || item.reference_id ? <CopyCell value={item.qrs?.reference_id || item.reference_id} className="pu-shq-ref" duration={2000} /> : <span className="pu-none">-</span>}
                          </td>
                        )}
                        {this.isColumn("customer") && (
                          <td data-label="Customer" className="text-nowrap">
                            <div className="pu-user">
                              <div className="min-w-0">
                                <div className="pu-name text-truncate d-flex align-items-center" title={custName}>
                                  <span className="text-truncate">{custName}</span>
                                  <span
                                    className={`icon ms-2 pointer pu-info-plain ${hover_info_index === index ? "active" : ""}`}
                                    title="Customer IDs"
                                    onMouseEnter={(event) => {
                                      this.setState({ hover_info_index: index });
                                      this.showInlineHelpPopup(event, {
                                        title: "Customer IDs",
                                        titleColor: "#344054",
                                        lines: idLines,
                                        copyable: true,
                                      });
                                    }}
                                    onMouseLeave={() => {
                                      this.setState({ hover_info_index: -1 });
                                      this.hideInlineHelpPopup();
                                    }}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      this.copyInlineHelpText(idLines.join("\n"));
                                    }}
                                  >
                                    {""}
                                  </span>
                                </div>
                                <div className="pu-sub">
                                  <span className="icon me-1">{""}</span>
                                  <span className="text-truncate">{brokerName}</span>
                                </div>
                              </div>
                            </div>
                          </td>
                        )}
                        {this.isColumn("bank") && (
                          <td data-label="Bank" className="text-nowrap">
                            {bank ? (
                              <div className="pu-bank">
                                <img alt="bank" src={require(`../../assets/images/bank/${bank.icon || "bank.png"}`)} width={28} height={28} />
                                <div className="min-w-0">
                                  <div className="pu-bank-code">{item.bank_code}</div>
                                  <div className="pu-sub pu-mono">{maskAccount(item.bank_account_number) || "-"}</div>
                                </div>
                              </div>
                            ) : (
                              <span className="pu-none">-</span>
                            )}
                          </td>
                        )}
                        {this.isColumn("amount") && (
                          <td data-label="Amount" className="text-nowrap text-end">
                            <div className="pu-amount">{toFixed(item.amount, 2)}</div>
                          </td>
                        )}
                        {this.isColumn("fee_rate") && (
                          <td data-label="Fee %" className="text-nowrap text-end pu-num">
                            {toFixed(item.fee_rate, 2)}%
                          </td>
                        )}
                        {this.isColumn("fee") && (
                          <td data-label="Fee" className="text-nowrap text-end pu-num">
                            {toFixed(item.fee, 2)}
                          </td>
                        )}
                        {this.isColumn("vat") && (
                          <td data-label="VAT" className="text-nowrap text-end pu-num">
                            {item.is_vat ? toFixed(item.vat, 2) : "0.00"}
                          </td>
                        )}
                        {this.isColumn("amount_net") && (
                          <td data-label="Amount Net" className="text-nowrap text-end">
                            <div className="pu-amount pu-amount-gold">{toFixed(item.amount_net, 2)}</div>
                          </td>
                        )}
                        {this.isColumn("process") && (
                          <td data-label="Process" className="text-nowrap text-center">
                            <div className="d-flex align-items-center justify-content-center">{item.process_type === "manual" ? Status("manual", "orange") : item.process_type === "auto" ? Status("auto", "primary") : Status("-", "secondary")}</div>
                          </td>
                        )}
                        {this.isColumn("status") && (
                          <td data-label="Status" className="text-nowrap text-center">
                            <div className="d-flex align-items-center justify-content-center">
                              {isExpiredCancel(item.status, item.status_reason)
                                ? // expired is a timeout, not a rejection: keep it
                                  // neutral so red stays reserved for real failures
                                  Status("cancel", "secondary")
                                : StatusTnx(item.status)}
                            </div>
                            {item.ref_no_refund && <div className="d-flex align-items-center justify-content-center mt-1">{Status("refund", "info")}</div>}
                          </td>
                        )}
                        {this.isColumn("actions") && (
                          <td data-label="Actions" className="mismatchs.update text-center td-actions">
                            {profile.user_type === "accounting" && (
                              <Dropdown align="end">
                                <Dropdown.Toggle className="pu-action-toggle" id={`mismatch-actions-acc-${index}`}>
                                  Action
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                  <Dropdown.Item
                                    className="pu-action-item"
                                    onClick={() => {
                                      this.setState({
                                        ...item,
                                        modal_detail: true,
                                      });
                                    }}
                                  >
                                    <span className="icon">{"\uf06e"}</span>Detail
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                            {profile.user_type !== "accounting" && (
                              <Dropdown align="end">
                                <Dropdown.Toggle className="pu-action-toggle" id={`mismatch-actions-${index}`}>
                                  Action
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                  <Dropdown.Item
                                    className="pu-action-item"
                                    onClick={() => {
                                      this.setState({ ...item, modal_detail: true });
                                    }}
                                  >
                                    <span className="icon">{""}</span>Detail
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    className="pu-action-item"
                                    onClick={() => {
                                      this.Share(item);
                                    }}
                                  >
                                    <span className="icon">{""}</span>Share
                                  </Dropdown.Item>
                                  {item.status === "mismatch" && (
                                    <>
                                      <div className="pu-action-sep" />
                                      <Dropdown.Item
                                        className="mismatchs.update pu-action-item"
                                        onClick={() => {
                                          this.setState({ ...item, status: "success" }, () => {
                                            this.Update();
                                          });
                                        }}
                                      >
                                        <span className="icon">{""}</span>Approve
                                      </Dropdown.Item>
                                      {!item.ref_no_refund && (
                                        <Dropdown.Item
                                          className="mismatchs.update pu-action-item danger"
                                          onClick={() => {
                                            this.setState({ ...item, refund_amount: Number(item.amount), modal_refund: true });
                                          }}
                                        >
                                          <span className="icon">{""}</span>Refund
                                        </Dropdown.Item>
                                      )}
                                    </>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination className="mb-3" count={Math.ceil(count / page_size) || 1} page={page} showFirstButton showLastButton onChange={(_, value) => this.Get(value)} />
          </div>
           {/* SHARE */}
                    <div style={{ opacity: 0, position: "absolute", left: -9999 }}>
                      <div className="wpx-450 p-3" id="share" ref={(el) => (this.share = el)} style={{
                  backgroundImage: `url(${WATERMARK})`,
                  backgroundRepeat: "repeat"
              }}>
                          <div className="d-flex justify-content-between">
                              <div>
                          <h4 className="fw-bold d-flex align-items-center mb-0">
                          {getShareTitle(
                              is_topup ? "topup" : type,
                              ref_no_refund && status === "success" ? "refund" : status,
                              )}

                          <div className="ms-2">{StatusTnxShare(status)}</div>
                          </h4>
                          <div className="w-100">
                          {format_date(created_at, "dd/mm/yyyy hh:mm:ss", "en")}
                          </div>
                          {ref_no_refund  ?(
                            <div>
                              <div className="w-100">Deposit Ref No: {ref_no_refund}</div>
                              <div className="w-100">Refund Ref No: {ref_no}</div>
                          </div>
                          ):(
                          <div className="w-100">Ref No: {ref_no}</div>
                        )}
                              </div>
                              <img alt="logo" src={LOGO512} height={50} style={{ objectFit: "contain" }} />
                          </div>
          
                          <hr />
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Broker</div>
                          <div className="w-100 mt-2">{broker?.name_en || "-"}</div>
                          </div>
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Customer</div>
                          <div className="w-100 mt-2">{customer?.name_en || "-"}</div>
                          </div>
                          
          
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Amount</div>
                          <div className="w-100 mt-2">
                              {toFixed(amount, 2)} {currency || "THB"}
                          </div>
                          </div>
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Fee</div>
                          <div className="w-100 mt-2">
                              {toFixed(fee, 2)} {currency || "THB"}
                          </div>
                          </div>
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Vat</div>
                          <div className="w-100 mt-2">
                              {toFixed(vat, 2)} {currency || "THB"}
                          </div>
                          </div>
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Amount Net</div>
                          <div className="w-100 mt-2">
                              {toFixed(amount_net, 2)} {currency || "THB"}
                          </div>
                          </div>
                          <div className="d-flex mb-1">
                          <div className="wpx-100 mt-2 fw-bold">Remark</div>
                          <div className="w-100 mt-2">{remark || status_reason || "-"}</div>
                          </div>
          
                          {bank_code && (
                          <>
                              <hr />
                              <div className="d-flex align-items-center">
                              <div className="wpx-100">
                                  <img
                                  alt="bank"
                                  src={require(
                                      `../../assets/images/bank/${global.bank.find((b) => b.value === bank_code)?.icon || "bank.png"}`,
                                  )}
                                  width={55}
                                  height={55}
                                  />
                              </div>
                              <div>
                                  <div className="w-100">
                                  {bank_account_name_en || bank_account_name_th}
                                  </div>
                                  <div className="w-100">{bank_code}</div>
                                  <div className="w-100">{maskAccount(bank_account_number)}</div>
                              </div>
                              </div>
                          </>
                          )}
                      </div>
                    </div>
        </div>

        {/* DETAIL */}
        <Modal show={modal_detail} size="lg" dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_detail: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Mismatch detail</div>
              <h5 className="fw-bold mb-0">
                Transaction <span className="pu-mono text-secondary fw-normal text-14">{ref_no}</span>
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <div className="pu-section h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Transaction
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Status</span>
                    <span className="pu-kv-value">{StatusTnx(status)}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Ref No.</span>
                    <span className="pu-kv-value pu-mono">{ref_no}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Time</span>
                    <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy", "en")}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Type</span>
                    <span className="pu-kv-value text-capitalize">{type}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Customer</span>
                    <span className="pu-kv-value">{customer?.name_en || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Broker</span>
                    <span className="pu-kv-value">{broker?.name_en || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Remark</span>
                    <span className="pu-kv-value">{remark || <span className="pu-none">-</span>}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Accountant Remark</span>
                    <span className="pu-kv-value">
                      <span className="pu-none">-</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="pu-section pu-section-gold h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Fee &amp; Amount
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee Rate Type</span>
                    <span className="pu-kv-value text-capitalize">{fee_type || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee Rate</span>
                    <span className="pu-kv-value">
                      {toFixed(fee_rate, 2)} {fee_type === "percentage" ? "%" : cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Amount</span>
                    <span className="pu-kv-value">
                      {toFixed(amount, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee Gateway</span>
                    <span className="pu-kv-value">
                      {toFixed(cost_gateway, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee</span>
                    <span className="pu-kv-value">
                      {toFixed(fee, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">VAT Type</span>
                    <span className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">VAT</span>
                    <span className="pu-kv-value">
                      {toFixed(vat, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv total">
                    <span className="pu-kv-label">Amount Net</span>
                    <span className="pu-kv-value">
                      {toFixed(amount_net, 2)} {cur}
                    </span>
                  </div>
                </div>
              </div>

              {/* เทียบบัญชีที่ลงทะเบียนไว้ กับบัญชีที่โอนเข้ามาจริง */}
              <div className="col-12 col-md-6">
                <div className="pu-section pu-mm-registered h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Registered Account
                    <span className="pu-section-note">Customer on file</span>
                  </div>
                  <div className="pu-bank mb-3">
                    <img alt="bank" src={require(`../../assets/images/bank/${bankIcon(bank_code)}`)} />
                    <div className="min-w-0">
                      <div className="pu-bank-code">{bank_code || "-"}</div>
                      <div className="pu-sub pu-mono">{maskAccount(bank_account_number) || "-"}</div>
                    </div>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Account Name EN</span>
                    <span className="pu-kv-value">{bank_account_name_en || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Account Name TH</span>
                    <span className="pu-kv-value">{bank_account_name_th || "-"}</span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="pu-section pu-mm-paying h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Paying Account
                    <span className="pu-section-note">Detected from transfer</span>
                  </div>
                  <div className="pu-bank mb-3">
                    <img alt="bank" src={require(`../../assets/images/bank/${mismatchBankIcon}`)} />
                    <div className="min-w-0">
                      <div className="pu-bank-code">{mismatchBankName}</div>
                      <div className="pu-sub pu-mono">{maskAccount(mismatch_bank_account_number) || "-"}</div>
                    </div>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Account Name EN</span>
                    <span className="pu-kv-value">{mismatch_bank_account_name_en || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Account Name TH</span>
                    <span className="pu-kv-value">{mismatch_bank_account_name_th || "-"}</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* REFUND */}
        <Modal show={modal_refund} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_refund: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Refund</div>
              <h5 className="fw-bold mb-0">Refund Order</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section pu-mm-paying">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Refund to paying account
              </div>
              <div className="pu-bank mb-3">
                <img alt="bank" src={require(`../../assets/images/bank/${mismatchBank?.icon || "bank.png"}`)} />
                <div className="min-w-0">
                  <div className="pu-bank-code">{mismatchBank?.label || "-"}</div>
                  <div className="pu-sub pu-mono">{maskAccount(mismatch_bank_account_number) || "-"}</div>
                </div>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Ref No.</span>
                <span className="pu-kv-value pu-mono">{ref_no}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Name TH</span>
                <span className="pu-kv-value">{mismatch_bank_account_name_th || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Name EN</span>
                <span className="pu-kv-value">{mismatch_bank_account_name_en || "-"}</span>
              </div>
            </div>
            <div className="pu-section pu-section-gold">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Amount
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Received Amount</span>
                <span className="pu-kv-value">
                  {toFixed(amount)} {filter_currency}
                </span>
              </div>
              <div className="pu-kv input">
                <span className="pu-kv-label">Refund Amount</span>
                <div className="position-relative">
                  <NumericFormat
                    thousandSeparator=","
                    decimalScale={2}
                    type="text"
                    className="form-control pr-input pu-kv-input pe-5"
                    placeholder="0.00"
                    value={refund_amount}
                    isAllowed={(values) => {
                      const { floatValue } = values;
                      if (floatValue === undefined) return true;
                      return floatValue <= Number(amount);
                    }}
                    onValueChange={(values) => {
                      this.setState({ refund_amount: values.value });
                    }}
                  />
                  <span className="pu-input-suffix">{filter_currency}</span>
                </div>
              </div>
              <div className="pu-hint">Refund amount cannot exceed the received amount.</div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill mismatchs.update"
              onClick={() => {
                this.Refund();
              }}
            >
              <span className="icon me-2">{""}</span>Refund
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_refund: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* SHARE */}
        <Modal show={modal_share} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_share: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Share</div>
              <h5 className="fw-bold mb-0">Share Transaction</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-cc-share-img mb-3">
              <img alt="share" src={share_image} width={"100%"} />
            </div>
            <label className="pr-label">Share to Group</label>
            <Select
              className="form-control"
              placeholder="Select group"
              options={global.chat_room.flatMap((group) =>
                (group?.list || []).map((chat) => ({
                  value: chat.value,
                  label: chat.label,
                }))
              )}
              value={chat_id}
              onChange={(v) => this.setState({ chat_id: v })}
            />
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer justify-content-between">
            <button
              type="button"
              className="pu-copy-btn"
              title="Download share image"
              onClick={() => {
                this.DownloadShare();
              }}
            >
              <span className="icon me-2">{""}</span>Download
            </button>
            <div className="d-flex">
              <button
                className="btn btn-dark px-4 me-1 rounded-pill"
                onClick={() => {
                  this.SubmitShare();
                }}
              >
                <span className="icon me-2">{""}</span>Share
              </button>
              <button
                className="btn btn-outline-dark px-4 ms-1 rounded-pill"
                onClick={() => {
                  this.setState({ modal_share: false });
                }}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
